import { render, staticRenderFns } from "./editReferralBanner.vue?vue&type=template&id=be0b0290&lang=pug"
import script from "./editReferralBanner.vue?vue&type=script&lang=js"
export * from "./editReferralBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports